import classNames from "classnames";

import { ReactComponent as CloseBtn } from "../../../assets/svg/Vector.svg";
import styles from "./modal.module.scss";

interface Props {
  visible: boolean;
  children: any;
  onCancel: () => void;
  size?: string;
  disableMaskClose?: boolean;
  disableCloseBtn?: boolean;
}

const Modal = ({
  visible,
  children,
  onCancel,
  size = "",
  disableMaskClose = false,
  disableCloseBtn = false,
}: Props) => {
  return (
    <>
      {visible ? (
        <div className={styles.modalContainer}>
          <div
            className={styles.mask}
            onClick={() => (disableMaskClose ? () => null : onCancel())}></div>
          <div className={classNames(styles.modal, styles[size])}>
            {disableCloseBtn ? null : (
              <button className={styles.closeBtn} onClick={onCancel}>
                <CloseBtn />
              </button>
            )}
            {children}
          </div>
        </div>
      ) : null}
    </>
  );
};

export default Modal;
